import React, { useState, useEffect } from 'react';
import { Router } from '@reach/router';
import Loader from '@accrosoft-ltd/vf-careers-site-theme/src/modules/Loader';
import HomepagePageContent from '@accrosoft-ltd/vf-careers-site-theme/src/templates/Homepage_Content';
import fetchJsonp from 'fetch-jsonp';
import { useCookies } from 'react-cookie';
import { trackAnalyticsEvent, trackAnalyticsPageView, useStateWithSessionStorage } from '@accrosoft-ltd/vf-careers-site-theme/src/components/analytics';
import { useTracking } from 'react-tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function HomepagePage(props) {
  var config = props.pageContext.config;
  var siteConfig = config;
  var apiKey = siteConfig.apiKey || props.smartfeedID;
  var gdprKey = siteConfig.gdprKey || props.apiKey || props.smartfeedID;
  var groupOrIdParam = siteConfig.group ? 'group' : 'id';

  var _useState = useState({}),
      smartfeedCompanyData = _useState[0],
      setSmartfeedCompanyData = _useState[1];

  var _useState2 = useState({}),
      appGatewayURL = _useState2[0],
      setAppGatewayURL = _useState2[1];

  var _useState3 = useState(true),
      vacanciesRouteLoading = _useState3[0],
      setVacanciesRouteLoading = _useState3[1];

  var _useState4 = useState(null),
      vacanciesRouteError = _useState4[0],
      setVacanciesRouteError = _useState4[1];

  var _useCookies = useCookies(['ap-signals-user-id']),
      cookies = _useCookies[0],
      setCookie = _useCookies[1];

  var _useStateWithSessionS = useStateWithSessionStorage('ap-signals-session-id'),
      sessionIDValue = _useStateWithSessionS[0],
      setSessionIDValue = _useStateWithSessionS[1];

  var _useTracking = useTracking({
    page: 'Homepage',
    location: props.location,
    apiKey: props.apiKey
  }, {
    dispatch: function dispatch(data) {
      return trackAnalyticsEvent(data, cookies['ap-signals-user-id'], sessionIDValue, siteConfig);
    }
  }),
      trackEvent = _useTracking.trackEvent;

  useEffect(function () {
    trackAnalyticsPageView(props.location, cookies['ap-signals-user-id'], sessionIDValue, siteConfig);
  }, [cookies, props.location, sessionIDValue, siteConfig]);
  useEffect(function () {
    if (apiKey) {
      var companyDetailsEndpoint = 'GetCompanyDetails';

      if (groupOrIdParam === 'group') {
        companyDetailsEndpoint = 'GetGroupDetails';
      }

      try {
        fetchJsonp(siteConfig.sfAPIEndpoint + '/CareerPage/' + companyDetailsEndpoint + '?id=' + apiKey, {
          timeout: 15000
        }).then(function (response) {
          return response.json();
        }).then(function (jsonList) {
          fetchJsonp(siteConfig.sfAPIEndpoint + '/CareerPage/' + 'GetApplicantGetwayURL' + '?companyId' + '=' + gdprKey, {
            timeout: 15000
          }).then(function (response) {
            return response.json();
          }).then(function (appgatway) {
            setVacanciesRouteLoading(false);

            if (jsonList && jsonList.CompanyDetails && jsonList.CompanyDetails.length > 0) {
              setSmartfeedCompanyData(jsonList.CompanyDetails[0]);
            } else {
              setSmartfeedCompanyData(jsonList);
            }

            setAppGatewayURL(appgatway);
          }).catch(function (ex) {
            setVacanciesRouteLoading(false);
            setVacanciesRouteError(ex);
            console.error(ex, 'error');
          });
        }).catch(function (ex) {
          setVacanciesRouteLoading(false);
          setVacanciesRouteError(ex);
          console.error(ex, 'error');
        });
      } catch (ex) {
        setVacanciesRouteLoading(false);
        setVacanciesRouteError(ex);
        console.error(ex, 'error');
      }
    } else {
      setVacanciesRouteLoading(false);
      setVacanciesRouteError('No API key was provided.');
    }
  }, [apiKey, gdprKey, groupOrIdParam, siteConfig.sfAPIEndpoint]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !siteConfig.companyCareersSite ? /*#__PURE__*/_jsx(Router, {
      children: /*#__PURE__*/_jsx(Loader, Object.assign({
        trackEvent: trackEvent,
        siteConfig: siteConfig,
        location: props.location,
        apiKey: apiKey,
        groupOrIdParam: groupOrIdParam,
        smartfeedCompanyData: smartfeedCompanyData,
        appGatewayURL: appGatewayURL,
        vacanciesRouteLoading: vacanciesRouteLoading,
        vacanciesRouteError: vacanciesRouteError
      }, props, {
        default: true
      }))
    }) : /*#__PURE__*/_jsx(HomepagePageContent, Object.assign({
      trackEvent: trackEvent,
      siteConfig: siteConfig,
      location: props.location,
      apiKey: apiKey,
      groupOrIdParam: groupOrIdParam,
      smartfeedCompanyData: smartfeedCompanyData,
      appGatewayURL: appGatewayURL,
      vacanciesRouteLoading: vacanciesRouteLoading,
      vacanciesRouteError: vacanciesRouteError,
      path: siteConfig.companyCareersSite ? '/' : '/'
    }, props))
  });
}